import { render, staticRenderFns } from "./ProgressChartsChart.vue?vue&type=template&id=4f4ffed4&"
import script from "./ProgressChartsChart.vue?vue&type=script&lang=js&"
export * from "./ProgressChartsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports